// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tqhre","importantInfo":"styles_importantInfo__1CGD-"};